import { createSelector } from 'reselect';

import getApplicationSelector from './getApplicationSelector';

export default createSelector([getApplicationSelector], (application) => application?.packageId);
